import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useRef } from 'react'
import { Button, ButtonColor, Icon, IconType } from '../../components'
import { Brand } from '../../gql/types'

interface IProps {
  brand: Brand
  open: boolean
  setOpen: (open: boolean) => void
}

export const LeaveClipReviewModal: React.FC<IProps> = ({
  open,
  setOpen,
  brand,
}) => {
  const cancelButtonRef = useRef(null)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as='div'
        className='relative z-10'
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
        </Transition.Child>

        <div className='fixed inset-0 z-10 overflow-y-auto'>
          <div className='flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            >
              <Dialog.Panel className='relative bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full'>
                <div className='bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4'>
                  <div className='sm:flex sm:items-start'>
                    <div className='mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10'>
                      <Icon
                        type={IconType.starFilled}
                        className='h-5 w-5 text-yellow-500'
                        aria-hidden='true'
                      />
                    </div>
                    <div className='mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left'>
                      <Dialog.Title
                        as='h3'
                        className='text-lg leading-6 font-medium text-gray-900'
                      >
                        Share Your Feedback About Clip
                      </Dialog.Title>
                      <div className='mt-2'>
                        <p className='text-sm text-gray-500'>
                          Please share your review on ReviewsIO or Trustpilot so
                          other brands can see what partnering with us is really
                          like.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse'>
                  <Button
                    onClick={() =>
                      window.open(
                        'https://www.reviews.io/company-reviews/store/www.useclip.com',
                        '_blank',
                      )
                    }
                    title='ReviewsIO'
                    className='w-full sm:ml-3 sm:w-auto'
                  />
                  <Button
                    onClick={() =>
                      window.open(
                        'https://www.trustpilot.com/review/useclip.com',
                        '_blank',
                      )
                    }
                    title='Trustpilot'
                    className='w-full sm:ml-3 sm:w-auto'
                  />
                  <Button
                    onClick={handleClose}
                    title='Cancel'
                    className='mt-3 w-full sm:mt-0 sm:w-auto'
                    ref={cancelButtonRef}
                    colour={ButtonColor.tertiary}
                  />
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
